import SuperAdminDashboard from "../superadmin/Dashboard";
import CustomerDetailsPage from "../superadmin/CustomerDetailsPage";
import UnderConstructionPage from "../components/CommonComponents/UnderConstructionIcon";
import ProtectedRoute from "./ProtectedRoute";
import { ThemeProvider } from "../components/CommonComponents/ThemeProvider";
import BranchesPage from "../superadmin/BranchesPage";
import MainLayout from "../components/CommonComponents/MainLayout";

export const superadminRoutes = [
    {
        path: "/superadmin/dashboard",
        element: <ProtectedRoute allowedRoles={[0]}><SuperAdminDashboard /></ProtectedRoute>,
    },
    {
        path: "/superadmin/customer-details",
        element: <ProtectedRoute allowedRoles={[0]}><CustomerDetailsPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/branches",
        element: (
            <ProtectedRoute allowedRoles={[0]}>
                <MainLayout>
                    <BranchesPage />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/superadmin/settings",
        element: <ProtectedRoute allowedRoles={[0]}><UnderConstructionPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/appearance",
        element: <ProtectedRoute allowedRoles={[0]}><ThemeProvider /></ProtectedRoute>,
    },
];
